module.exports = __webpack_public_path__ + "static/img/2021.227ce19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021.jpg
// module id = 311
// module chunks = 0